module.exports = __webpack_public_path__ + "img/arrow_foward-gray.f84cd539.svg";